import { __decorate } from "tslib";
import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let NumberFormatterServiceImpl = class NumberFormatterServiceImpl {
    formatNumber(num) {
        if (!_.isNumber(num))
            return num;
        // eslint-disable-next-line prefer-const
        let [left, right] = num.toString().split('.');
        left = left.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');
        return _.compact([left, right]).join('.');
    }
};
NumberFormatterServiceImpl = __decorate([
    injectable()
], NumberFormatterServiceImpl);
export { NumberFormatterServiceImpl };
